"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

type Operador = { id: string; nombre: string; rol: string };

export default function PanelLogin() {
  const router = useRouter();
  const [ops, setOps] = useState<Operador[]>([]);
  const [sel, setSel] = useState<Operador | null>(null);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    fetch("/api/operadores/activos").then((r) => r.json())
      .then((d) => setOps(d.operadores ?? []))
      .catch(() => setError("No se pudo cargar la lista"));
  }, []);

  function agregar(d: string) { if (pin.length >= 8) return; setError(""); setPin((p) => p + d); }

  async function entrar() {
    if (!sel || !pin || cargando) return;
    setCargando(true); setError("");
    try {
      const d = await fetch("/api/auth/login", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ operador_id: sel.id, pin }),
      }).then((r) => r.json());
      if (d.ok) router.refresh();
      else { setError(d.error ?? "PIN incorrecto"); setPin(""); }
    } catch { setError("Error de conexión"); setPin(""); }
    finally { setCargando(false); }
  }

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-black tracking-tight text-[var(--acento)]">Comandas</h1>
          <p className="text-sm text-neutral-500 mt-2">Panel de eventos</p>
        </div>
        {!sel ? (
          <div className="space-y-3">
            <p className="text-center text-neutral-400 text-sm mb-2">¿Quién sos?</p>
            {ops.map((op) => (
              <button key={op.id} onClick={() => setSel(op)}
                className="w-full py-4 px-5 rounded-2xl bg-neutral-900 border border-neutral-800 text-left hover:border-[var(--acento)] transition-colors">
                <span className="font-semibold">{op.nombre}</span>
                <span className="text-xs text-neutral-500 ml-2 uppercase">{op.rol}</span>
              </button>
            ))}
            {ops.length === 0 && !error && <p className="text-center text-neutral-600 text-sm">Cargando…</p>}
            {error && <p className="text-center text-red-400 text-sm">{error}</p>}
          </div>
        ) : (
          <div>
            <button onClick={() => { setSel(null); setPin(""); setError(""); }} className="text-neutral-500 text-sm mb-4 hover:text-neutral-300">← Cambiar usuario</button>
            <p className="text-center text-lg font-semibold mb-1">{sel.nombre}</p>
            <p className="text-center text-neutral-500 text-xs mb-6">Ingresá tu PIN</p>
            <div className="flex justify-center gap-3 mb-6 h-4">
              {Array.from({ length: Math.max(pin.length, 4) }).map((_, i) => (
                <span key={i} className={`w-3 h-3 rounded-full ${i < pin.length ? "bg-[var(--acento)]" : "bg-neutral-800"}`} />
              ))}
            </div>
            <div className="grid grid-cols-3 gap-3">
              {["1","2","3","4","5","6","7","8","9"].map((n) => (
                <button key={n} onClick={() => agregar(n)} className="py-5 rounded-2xl bg-neutral-900 border border-neutral-800 text-2xl font-semibold active:bg-neutral-800">{n}</button>
              ))}
              <button onClick={() => setPin((p) => p.slice(0, -1))} className="py-5 rounded-2xl text-2xl text-neutral-500 active:bg-neutral-900">←</button>
              <button onClick={() => agregar("0")} className="py-5 rounded-2xl bg-neutral-900 border border-neutral-800 text-2xl font-semibold active:bg-neutral-800">0</button>
              <button onClick={entrar} disabled={!pin || cargando} className="py-5 rounded-2xl text-2xl font-bold text-white bg-[var(--acento)] disabled:opacity-30">✓</button>
            </div>
            {error && <p className="text-center text-red-400 text-sm mt-5">{error}</p>}
          </div>
        )}
      </div>
    </main>
  );
}
